import React from 'react';
import { partial } from 'ramda';
import { connect } from 'react-redux';
import {
  limitChange,
  offsetChange,
} from 'browse-media/redux/browseMediaActions';
import { Button } from 'react-toolbox/lib/button';
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu';
import styles from 'browse-media/components/BrowseMediaSearchResultsPager.css';

const BrowseMediaSearchResultsPager = ({
  hasNext,
  hasPrevious,
  limit,
  onChangeLimit,
  onChangeOffset,
  offset,
  totalCount,
}) => (
  <div className={styles.container}>
    <span className={styles.text}>Rows per page:</span>
    <span className={styles.limit}>{limit}</span>
    <IconMenu
      icon="arrow_drop_down"
      position="bottomRight"
      menuRipple
      theme={styles}
    >
      <MenuItem
        value={20}
        caption="20"
        onClick={partial(onChangeLimit, [20])}
      />
      <MenuItem
        value={50}
        caption="50"
        onClick={partial(onChangeLimit, [50])}
      />
      <MenuItem
        value={100}
        caption="100"
        onClick={partial(onChangeLimit, [100])}
      />
      <MenuItem
        value={400}
        caption="400"
        onClick={partial(onChangeLimit, [400])}
      />
    </IconMenu>
    {totalCount > 0 && (
      <span className={styles.text}>
        {offset + 1} - {hasNext ? offset + limit : totalCount} of {totalCount}
      </span>
    )}
    <Button
      icon="chevron_left"
      theme={styles}
      disabled={!hasPrevious}
      onClick={() => {
        onChangeOffset(offset - limit);
      }}
    />
    <Button
      icon="chevron_right"
      theme={styles}
      disabled={!hasNext}
      onClick={() => {
        onChangeOffset(offset + limit);
      }}
    />
  </div>
);

const mapStateToProps = state => {
  const { offset, limit, totalCount } = state.browseMedia;

  return {
    hasNext: offset + limit < totalCount,
    hasPrevious: offset > 0,
    limit,
    offset,
    totalCount,
  };
};

const mapDispatchToProps = dispatch => ({
  onChangeOffset: offset => dispatch(offsetChange(offset)),
  onChangeLimit: limit => dispatch(limitChange(limit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  BrowseMediaSearchResultsPager,
);
